var map = {
	"./@communications/communications.module.ngfactory": [
		"./src/app/@features/@communications/communications.module.ngfactory.js",
		0,
		"common",
		7
	],
	"./@communicationshub/communicationshub.module.ngfactory": [
		"./src/app/@features/@communicationshub/communicationshub.module.ngfactory.js",
		"common",
		2
	],
	"./@events/events.module.ngfactory": [
		"./src/app/@features/@events/events.module.ngfactory.js",
		0,
		"common",
		4
	],
	"./@inventory/inventory.module.ngfactory": [
		"./src/app/@features/@inventory/inventory.module.ngfactory.js",
		0,
		1,
		"common",
		6
	],
	"./@orders/orders.module.ngfactory": [
		"./src/app/@features/@orders/orders.module.ngfactory.js",
		0,
		1,
		"common",
		3
	],
	"./@ordersarchives/ordersarchives.module.ngfactory": [
		"./src/app/@features/@ordersarchives/ordersarchives.module.ngfactory.js",
		"common",
		5
	],
	"./@stagedorders/stagedorders.module.ngfactory": [
		"./src/app/@features/@stagedorders/stagedorders.module.ngfactory.js",
		0,
		"common",
		8
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];
	if(!ids) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		var id = ids[0];
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "./src/$$_lazy_route_resource lazy recursive";
module.exports = webpackAsyncContext;